
import axios from '../../rest.config';
import { PuzzleData, WordStart, PuzzleBuild, Note } from './vo';
import { AxiosResponse } from 'axios';
import { PuzzleResponse, PuzzleListItem, ResponseListItem } from 'vue/types/vue';

class PuzzleServiceImpl {



    async getPuzzleById(id: string): Promise<PuzzleData[]> {

        const puzzle: PuzzleData[] = new Array<PuzzleData>();
        try {

            const response = await axios().get("/api/v1/open/puzzle/get", { params: { p: id } });
            const data: any = response.data;
            const puzzleData: PuzzleData = new PuzzleData(data.pname, data.viewSolution);
            puzzleData.setState(data.state);
            puzzleData.setArrows(data.arrows);
            puzzleData.setDashes(data.dashes);
            puzzleData.setId(data.id);

            const starts: WordStart[] = [];
            for (let i = 0; i < data.wordStarts.length; i++) {
                const x: number = data.wordStarts[i].x;
                const y: number = data.wordStarts[i].y;
                starts.push(new WordStart(x, y));
            }
            puzzleData.setWordStarts(starts);
            //console.log(puzzleData);
            puzzle.push(puzzleData);
            return puzzle;
        }
        catch (error: any) {
            throw new Array<PuzzleData>();
        }
    }

    async getPuzzleNotes(puzzleid: string): Promise<Note[]> {
        try {

            const response = await axios().get("/api/v1/puzzle/notes", {
                params: { p: puzzleid }
            });
            const notesRaw = response.data;
            const notes: Note[] = new Array<Note>();
            for (const n of notesRaw) {
                const track = ((note) => {
                    let t = "";
                    if (note.hasOwnProperty('song'))
                        t = note.song;
                    else if (note.hasOwnProperty('track'))
                        t = note.track

                    return t
                })(n);
                const note = new Note(track, n.text, n.noteId);
                notes.push(note);
            }
            return notes;
        }
        catch (error: any) {
            return [];
        }
    }

    async getPuzzleSolution(puzzleid: string): Promise<string[]> {
        const solution = await axios().get("/api/v1/puzzle/solution", {
            params: { p: puzzleid }
        });

        const solutionArr: string[] = solution.data;

        return solutionArr;
    }

    async getPuzzleResponses(name: string): Promise<Array<ResponseListItem>> {

        const response: AxiosResponse = await axios().get("/api/v1/puzzle/responses", {
            params: { p: name }
        });


        const responses: ResponseListItem[] = response.data;

        return responses;
    }

    async canEditPuzzle(puzzleid: string): Promise<AxiosResponse> {
        const response: AxiosResponse = await axios().get("/api/v1/puzzle/editable", {
            params: { p: puzzleid }
        });
        return response
    }

    async puzzleExists(name: string): Promise<AxiosResponse> {
        const response: AxiosResponse = await axios().get("/api/v1/open/puzzle/exists", {
            params: { p: name }
        });

        return response;
    }
    async createPuzzle(puzzle: PuzzleBuild): Promise<string> { //TODO: PuzzleObject
        try {

            const res = await axios().post("/api/v1/puzzle/create", puzzle);
            return res.data.puzzleid;
        }
        catch (error: any) {
            throw { message: error.response.data };
        }
    }

    async updatePuzzle(puzzle: PuzzleBuild, puzzleid: string): Promise<string> {
        try {
            const data = {
                puzzleData: puzzle,
                id: puzzleid
            }
            const res = await axios().post("/api/v1/puzzle/update", data);
            return res.data.puzzleid;
        }
        catch (error: any) {
            throw { message: error.response.data };
        }
    }

    async getAllUserPuzzles(): Promise<PuzzleListItem[]> {
        const response: AxiosResponse = await axios().get("/api/v1/puzzle/get/all");
        const puzzleList: PuzzleListItem[] = response.data;
        return puzzleList;
    }

    async submitResponse(submit: PuzzleResponse): Promise<void> {
        try {

            await axios().post("/api/v1/open/puzzle/submit", submit);
        }
        catch (error: any) {
            let errMessage = error.response.data;
            if (error.response.status === 429) {
                errMessage = "Du har skickat in ditt kryss för många gånger. Vänta en liten stund innan du skickar in på nytt."
            }
            throw errMessage;
        }
    }
    async deletePuzzle(puzzleid: string): Promise<void> {
        await axios().delete("/api/v1/puzzle/delete", { params: { puzzleid: puzzleid } });
    }

}






export const PuzzleService = new PuzzleServiceImpl();